// useAddComment Hook
import { useState, useCallback, useMemo } from "react";
import { QueryCommentEntity } from "../../domain/entities/QueryCommentEntity";
import { AddCommentUseCase } from "../../domain/use-cases/AddCommentUseCase";
import { QueriesRepositoryImpl } from "../../data/repositories/QueriesRepositoryImpl";
import { queriesApi } from "../../data/api/queriesApi";
import { Result } from "../../domain/common/Result";

export const useAddComment = () => {
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Instantiate repository and use case
  const repository = useMemo(
    () => new QueriesRepositoryImpl(queriesApi),
    []
  );

  const addCommentUseCase = useMemo(
    () => new AddCommentUseCase(repository),
    [repository]
  );

  const addComment = useCallback(
    async (queryId: number, comment: string): Promise<Result<QueryCommentEntity>> => {
      setAdding(true);
      setError(null);

      const result = await addCommentUseCase.execute({ queryId, comment });

      if (result.isFailure) {
        setError(result.error);
      }

      setAdding(false);
      return result;
    },
    [addCommentUseCase]
  );

  return {
    addComment,
    adding,
    error,
  };
};

